var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"amui-badge",class:{ 'amui-badge--small': _vm.small }},[_c('span',{staticClass:"amui-badge__label"},[_vm._v(" "+_vm._s(_vm.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }